/** Tiny hook that swaps the <meta name="robots"> tag to noindex on private
 * routes (/admin, /portal, /login) and back to index/follow elsewhere. */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PRIVATE_PREFIXES = ["/admin", "/portal", "/login"];

export default function useRobotsMeta() {
  const location = useLocation();
  useEffect(() => {
    const isPrivate = PRIVATE_PREFIXES.some((p) =>
      location.pathname.startsWith(p),
    );
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      isPrivate ? "noindex, nofollow" : "index, follow",
    );
  }, [location.pathname]);
}
